<template>
            <v-container fluid grid-list-xs>
              <v-dialog v-model="scheduleModal" max-width="530px" persistent>
                <v-card light>

                  <v-card-title class="headline grey--text">
                      Agregar horario
                  </v-card-title>
                  <v-card-text class="pt-0">
                    <v-alert v-if="error" color="error" icon="warning"  value="true">
                      {{error}}
                    </v-alert>
                    <h6 v-if="sheduleModalDay">{{sheduleModalDay.full}}</h6>
                    <v-time-picker v-model="sheduleModalTime"  :landscape="true"></v-time-picker>
                    <v-text-field
                        label="Duración (min)"
                        v-model="sheduleModalDuration"
                        light
                        type="number"
                        color="green"
                        ref="gameTime"
                    ></v-text-field>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" flat @click.native="scheduleModal = false">No</v-btn>
                    <v-btn color="green darken-1" flat @click.native="okSheduleModal()">Si</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
                <v-layout row wrap>
                    <v-flex class="column hours" xs3 sm3>

                    </v-flex>
                    <v-flex v-for="(day, index) in days" :key="index" class="column text-xs-center" xs1 sm1>
                      {{day.short}}
                    </v-flex>



                </v-layout>

                <v-layout row wrap>
                    <v-flex  class="column hours" xs3 sm3 ma-0 pa-0>
                      <v-flex v-for="(hour, index) in hours" :key="index" xs12 sm12 :class="isOddNumber(index) ? 'cell gray' : 'cell'" >
                        {{hour}}
                      </v-flex>
                    </v-flex>

                    <v-flex v-for="(day, index0) in days" :key="index0" class="column" xs1 sm1 ma-0 pa-0>
                      <v-flex v-for="(hour, index)  in hours" :key="index" @click="showScheduleModal(hour,day)" xs12 sm12 :class="isOddNumber(index) ? 'cell gray' : 'cell'">

                      </v-flex>
                      <div class="interval" v-for="(interval, index1) in day.timeIntervals" :style="'top:'+interval.cssTop+';bottom:'+interval.cssBottom" @click.native="removeInterval(interval)"/>

                      </div>
                    </v-flex>



                </v-layout>

            </v-container>

</template>

<script>
import Utils from '@/utils/utils'
import moment from 'moment'


export default {
    name: 'WeeklyHoursSelector',
    props: {
      model: { required: true, default: [] }
    },
    components: {

    },
    data() {
        return {
          scheduleModal:false,
          sheduleModalTime: '03:50 AM',
          sheduleModalDuration: 45,
          sheduleModalDay: null,
          error:null,
          days:[
            {
              short:"Dom",
              full:"Domingo",
              timeIntervals:[]
            },
            {
              short:"Lun",
              full:"Lunes",
              timeIntervals:[]
            },
            {
              short:"Mar",
              full:"Martes",
              timeIntervals:[]
            },
            {
              short:"Mie",
              full:"Miercoles",
              timeIntervals:[]
            },
            {
              short:"Jue",
              full:"Jueves",
              timeIntervals:[]
            },
            {
              short:"Vie",
              full:"Viernes",
              timeIntervals:[]
            },
            {
              short:"Sab",
              full:"Sabado",
              timeIntervals:[]
            }


          ],
          hours:[
            '12:00 AM','12:30 AM',
            '01:00 AM','01:30 AM',
            '02:00 AM','02:30 AM',
            '03:00 AM','03:30 AM',
            '04:00 AM','04:30 AM',
            '05:00 AM','05:30 AM',
            '06:00 AM','06:30 AM',
            '07:00 AM','07:30 AM',
            '08:00 AM','08:30 AM',
            '09:00 AM','09:30 AM',
            '10:00 AM','10:30 AM',
            '11:00 AM','11:30 AM',
            '12:00 PM','12:30 PM',
            '01:00 PM','01:30 PM',
            '02:00 PM','02:30 PM',
            '03:00 PM','03:30 PM',
            '04:00 PM','04:30 PM',
            '05:00 PM','05:30 PM',
            '06:00 PM','06:30 PM',
            '07:00 PM','07:30 PM',
            '08:00 PM','08:30 PM',
            '09:00 PM','09:30 PM',
            '10:00 PM','10:30 PM',
            '11:00 PM','11:30 PM'
          ]
        }
    },
    watch: {


    },
    computed: {

    },
    methods: {
      cancel(){

      },
      confirm(){

      },
      showScheduleModal(time,day){
        this.error = null
        this.scheduleModal = true
        this.sheduleModalTime = time
        this.sheduleModalDay = day
        this.sheduleModalDuration = 45
      },
      okSheduleModal(){
        //this.scheduleModal = true
        var timeInterval = {}
        timeInterval.initialTime = Utils.parseTime(this.sheduleModalTime)
        timeInterval.finalTime = Utils.sumMinutes(timeInterval.initialTime,this.sheduleModalDuration)
        timeInterval.duration = this.sheduleModalDuration
        timeInterval.cssTop = Utils.getDayPercent(timeInterval.initialTime) + "%"
        timeInterval.cssBottom = (100 - Utils.getDayPercent(timeInterval.finalTime)) + "%"
        timeInterval.day = this.days.indexOf(this.sheduleModalDay)

        /*
          El objeto model es un Array bidimencional
          cada item del primer nivel del array es un
          dia de la semana (0 = Domingo), dicho item
          a su ves es otro arreglo con los intervalos
          de tiempo de dicho dia
        */
        this.model = this.model == null ? [] : this.model
        if(this.model.length < 7){ this.model.push([],[],[],[],[],[],[])}

        if(!this.checkOverloaps(timeInterval)){
          return
        }

        this.model[timeInterval.day].push(timeInterval)
        this.sheduleModalDay.timeIntervals.push(timeInterval)
        this.scheduleModal = false
      },
      isOddNumber(n){
        return n % 2 == 0
      },
      removeInterval(interval){
        console.log("removeInterval",interval)
      },
      checkOverloaps(interval){
        let daymodel = this.model[interval.day]
        let totalIntervals =  daymodel.length
        for(var i = 0; i<totalIntervals;i++){
          let intervalToCompare = daymodel[i]
          let date1 = moment(`2018-03-03 ${interval.initialTime.hours}:${interval.initialTime.minutes}`)
          let finalDate1 = moment(`2018-03-03 ${interval.finalTime.hours}:${interval.finalTime.minutes}`)
          let date2 = moment(`2018-03-03 ${intervalToCompare.initialTime.hours}:${intervalToCompare.initialTime.minutes}`)
          let finalDate2 = moment(`2018-03-03 ${intervalToCompare.finalTime.hours}:${intervalToCompare.finalTime.minutes}`)
          if(Utils.overlapsByDates(date1,date2,finalDate1,finalDate2)){
            this.error = "Ya existe un horario que se sobrepone a este"
            return false
          }
        }
        this.error = null
        return true
      }
    }
}
</script>

<style lang="css" scoped>
.cell{
  height: 25px;
  border-style: solid;
  border-color: #a0a0a0;
  border-bottom-width:  1px;
  border-top-width: 0px;
  border-right-width: 0px;
  border-left-width: 0px;
}
.column{
  position: relative;
  border-style: solid;
  border-color: #a0a0a0;
  border-bottom-width:  0px;
  border-top-width: 0px;
  border-right-width: 1px;
  border-left-width: 0px;
  width: 12% !important;
  max-width: 12% !important;
}
.column.hours{
  width: 16% !important;
  max-width: 16% !important;
}
.absolute-container{
  position: absolute;
  top: 50%;
  left:0px;
  right: 0px;
  bottom: 45%;
  background: #FF0000;
}

.gray{
  background: #eaeaea;
}

.interval{
  position: absolute;
  left: 0px;
  right: 0px;
  background-color: #FF0000;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/tournaments/tournament_calendar/WeeklyHoursSelector.vue